import { Container, Row } from "react-bootstrap";

import CustomLoadingOverlay from "./CustomLoadingOverlay";
import NavbarComponent from "./NavbarComponent";
import AlertComponent from "./AlertComponent";

type PageWrapperProps = {
  isLoading: boolean;
  loadingText?: string;
  alert: string;
  alertMessage: string;
  onClose: () => void;
  children: React.ReactNode;
};

const PageWrapper = ({
  isLoading,
  loadingText,
  alert,
  alertMessage,
  onClose,
  children,
}: PageWrapperProps) => {
  return (
    <>
      <AlertComponent
        variant={alert}
        message={alertMessage}
        onClose={onClose}
        fixedTop
      />
      <CustomLoadingOverlay fullHeight active={isLoading} text={loadingText}>
        <Container fluid>
          <NavbarComponent />
          <Row className="mt-3">{children}</Row>
        </Container>
      </CustomLoadingOverlay>
    </>
  );
};

export default PageWrapper;
